<nb-card>
  <nb-card-header>
    Add a new event notification
  </nb-card-header>
  <nb-card-body>
    <div class="form-group">
      <input type="text" nbInput fullWidth [(ngModel)]="message">
    </div>
    <button (click)="addNotification()" nbButton status="success" [disabled]="!(this.message && this.message.length > 10)">Add</button>
  </nb-card-body>
</nb-card>
<nb-card>
  <nb-card-header>
    Event notifications
  </nb-card-header>
  <nb-card-body>
    <angular2-smart-table [settings]="settings" [source]="source">
    </angular2-smart-table>
  </nb-card-body>
</nb-card>
